<template>
  <article class="card" :class="modifiers">
    <div class="card__side">
      <time
        v-if="prettyDate"
        class="card__date"
        v-html="prettyDate"
      />
      <slot name="side" />
    </div>
    <div class="card__main">
      <BaseTitle
        v-if="title"
        v-html="title"
        size="xl"
        is-up
        class="card__title"
      />
      <BaseText
        v-if="subtitle"
        v-html="subtitle"
      />
      <div
        v-if="age"
        v-html="age"
        class="card__badge"
      />
      <div v-if="$slots.actions" class="card__actions">
        <slot name="actions" />
      </div>
      <slot name="main" />
    </div>
  </article>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'Card',
  components: {
    BaseTitle,
    BaseText,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    age: {
      type: String,
      default: '',
    },
    date: {
      type: Date,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        card_selected: this.isSelected,
      };
    },
    prettyDate() {
      const [day, weekday, time] = [
        { day: 'numeric', month: 'long' },
        { weekday: 'short' },
        { hour: '2-digit', minute: '2-digit' },
      ].map((options) => new Intl.DateTimeFormat(this.$i18n.locale, options).format(this.date));
      return `<b>${day}</b><span>(${weekday}) | ${time}</span>`;
    },
  },
};
</script>

<style lang="stylus">
.card
  position relative
  display flex
  padding 1.8em 0 1.7em 0

  &:before
    content ''
    abs top left right bottom
    border solid currentColor
    border-width $border_width 0
    margin-bottom $border_width * -1

  &_selected
    &:before
      border-width $border_width
      box-shadow -0.4em 0.4em 0 0 $c_bright

  &__side
    flex 0 0 17em
    max-width 17em
    padding-left 1.5em

  &__main
    position relative
    flex-grow 1
    flex-basis 0
    max-width 100%
    ~/__side ~ &
      max-width calc(100% - 17em)

  &__title
    margin-top -0.2em
    margin-bottom 0.1em

  &__date
    display block
    font-size 1.5em
    font-weight 900
    line-height 1.2
    b
      margin-right 0.5em
    span
      display inline-block
      vertical-align top
      text-transform uppercase
      white-space nowrap
      font-size 0.6em

  &__badge
    abs top right
    padding-right 1.5em

  &__actions
    margin-top 1.25em
    .button
      margin-left 0.7em
      &:first-child
        margin-left 0
</style>
